import axios from "axios";

function readCookie(name) {
  const prefix = `${encodeURIComponent(name)}=`;
  return document.cookie.split("; ").find((entry) => entry.startsWith(prefix))?.slice(prefix.length) || "";
}

function isHakeRequest(config) {
  return String(config.url || "").startsWith("/admin/hake");
}

export const apiClient = axios.create({ baseURL: "/gateway/api", withCredentials: true, timeout: 15000 });
apiClient.interceptors.request.use((config) => {
  if (!["get", "head", "options"].includes((config.method || "get").toLowerCase())) {
    const cookieName = isHakeRequest(config) ? "hake_csrf" : "ac_csrf";
    const csrf = readCookie(cookieName);
    if (csrf) config.headers["X-CSRF-Token"] = decodeURIComponent(csrf);
  }
  return config;
});
apiClient.interceptors.response.use((response) => response, (error) => {
  const path = window.location.pathname;
  if (error.response?.status === 401 && path.startsWith("/admin/hake") && path !== "/admin/hake/login") {
    window.location.assign("/admin/hake/login");
  } else if (error.response?.status === 401 && path.startsWith("/admin") && path !== "/admin/login") {
    window.dispatchEvent(new CustomEvent("admin-session-expired"));
    window.location.assign("/admin/login");
  }
  return Promise.reject(error);
});
